export default __webpack_public_path__ + "static/media/pv-1.1d749116.png";